import * as S from './styles'
import React, {PropsWithChildren} from "react";

export enum ModalSize {
    large, medium, small
}

export interface ModalProps {
    show: boolean
    close: React.MouseEventHandler<HTMLElement>
    modalSize?: ModalSize
}

export const SimpleModal = ({show, close, children, modalSize = ModalSize.medium}: PropsWithChildren<ModalProps>) => {
    if (!show) return null;

    return (
        <S.Modal onClick={close}>
            <S.Content modalSize={modalSize} onClick={e => e.stopPropagation()}>
                <S.Body>
                    {children}
                </S.Body>
            </S.Content>
        </S.Modal>
    )
}